module.exports = __webpack_public_path__ + "static/img/repast01.20e29ca9.jpg";